'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Card } from '@components/card';
import { Sanitizer } from '@components/sanitizer';
import { TabsContentSection } from '@components/tabsContentSection';
import { Typography } from '@components/typography';

import { HowItWorksItem } from '../types';

interface HowItWorksContentSectionProps {
  items: HowItWorksItem[];
  /** Данные AppImage по imgSrcKey / imgSrcKeySm из `getAppImagesDataWithSizes`. */
  imagesDataMap: Record<string, AppImageData>;
  imageHeight: number;
  imageWidth: number;
}

export const HowItWorksContentSection = ({
  items,
  imagesDataMap,
  imageHeight,
  imageWidth,
}: HowItWorksContentSectionProps) => {
  return (
    <TabsContentSection items={items}>
      {(activeItem) => {
        return (
          <>
            {/** WEB */}
            <Card className="max-sm:hidden">
              <div className="flex gap-15 p-9">
                <div
                  className="flex flex-col justify-between"
                  style={{ height: imageHeight }}
                >
                  <div className="flex flex-col gap-3">
                    <Typography variant="heading-m">
                      {activeItem.title}
                    </Typography>

                    <Typography variant="text-base">
                      <Sanitizer
                        htmlContent={activeItem.description}
                        as="span"
                      />
                    </Typography>
                  </div>

                  <Typography
                    variant="text-l"
                    className="text-text-base-tertiary"
                  >
                    {activeItem.id}
                  </Typography>
                </div>

                <div
                  className="flex shrink-0"
                  style={{ height: imageHeight, width: imageWidth }}
                >
                  <AppImageClient
                    key={activeItem.imgSrcKey}
                    {...imagesDataMap[activeItem.imgSrcKey]}
                    alt={activeItem.title}
                  />
                </div>
              </div>
            </Card>

            {/** Mobile */}
            <div className="pr-4 md:hidden">
              <Card>
                <div className="flex flex-col gap-6 p-5">
                  <div className="flex flex-col justify-between">
                    <div className="flex flex-col gap-3">
                      <Typography variant="heading-s">
                        {activeItem.title}
                      </Typography>

                      <Typography variant="text-base">
                        <Sanitizer
                          htmlContent={activeItem.description}
                          as="span"
                        />
                      </Typography>
                    </div>
                  </div>

                  {activeItem.imgSrcKeySm && (
                    <AppImageClient
                      key={activeItem.imgSrcKeySm}
                      {...imagesDataMap[activeItem.imgSrcKeySm]}
                      alt={activeItem.title}
                      className="h-[316px] w-auto object-contain"
                    />
                  )}
                </div>
              </Card>
            </div>
          </>
        );
      }}
    </TabsContentSection>
  );
};
